import { render, staticRenderFns } from "./GlobalPartnersListView.vue?vue&type=template&id=41ea0732&scoped=true"
import script from "./GlobalPartnersListView.vue?vue&type=script&lang=js"
export * from "./GlobalPartnersListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ea0732",
  null
  
)

export default component.exports